export default __webpack_public_path__ + "static/media/eduPink.e254bf99.svg";